import { render } from "./popup-setor-harian-kurir.vue?vue&type=template&id=681e3e55&ts=true"
import script from "./popup-setor-harian-kurir.vue?vue&type=script&lang=ts"
export * from "./popup-setor-harian-kurir.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__